


















































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class ProjectCreateHeader extends Vue {
  @Prop()
  private projectId: any;
  @Prop()
  private step: any;
  @Prop()
  private secondState: string | undefined;
  @Prop()
  private thirdState: string | undefined;
  @Prop()
  private cState: any;
  private get tranState() {
    let num: number = 1;
    switch (this.step) {
      case "first":
        num = 0;
        break;
      case "second":
        num = 1;
        break;
      case "third":
        num = 2;
        break;
    }
    return num;
  }
  /**
   * @description 保存
   */
  private save() {
    this.$emit("save");
  }
  /**
   * @description 前往第二步页面
   */
  private goToSecond() {
    this.$emit("next");
  }
  /**
   * @description 返回第一页
   */
  private backToFirst() {
    this.$emit("back");
  }
  /**
   * @description 前往第三页
   */
  private goToThird() {
    this.$emit("next");
  }
  /**
   * @description 返回第二页
   */
  private backToSecond() {
    this.$emit("back");
  }
  /**
   * @description 第三页保存
   */
  private thirdSave() {
    this.$emit("save");
  }
}
